export const CHATBOT_TYPES = ['skinseoul', 'creatorhub'] as const;

export type ChatbotType = (typeof CHATBOT_TYPES)[number];

export const DEFAULT_CHATBOT_TYPE: ChatbotType = 'skinseoul';

export const VISIBLE_CHATBOT_TYPES: readonly ChatbotType[] = CHATBOT_TYPES;

export const CHATBOT_TYPE_LABELS: Record<ChatbotType, string> = {
  skinseoul: 'SkinSeoul CS',
  creatorhub: 'CreatorHub',
};
